<div
  class="container-fluid px-0 alignment bg-light"
  id="div_container-fluid_d8966a8c"
>
  <app-side-navigation
    *ngIf="currentStep !== request_steps_enums.SUBMIT"
    [currentStep]="currentStep"
  ></app-side-navigation>

  <div
    [ngSwitch]="currentStep"
    [class.full-width]="currentStep !== request_steps_enums.SELECTION"
    id="div_9510b2e9"
  >
    <div *ngSwitchCase="request_steps_enums.SELECTION" id="div_e995db6d">
      <app-your-selections></app-your-selections>
    </div>
    <div
      class="full-width"
      *ngSwitchCase="request_steps_enums.MECHANICAL_OPTIONS"
      id="div_full-width_57e2464d"
    >
      <span
        *ngIf="
          selectedCarType != enum_car_type.GONDOLA &&
          selectedCarType != enum_car_type.OPEN_HOPPER
        "
        id="span_86518305"
      >
        <app-mechanical-options></app-mechanical-options>
      </span>
    </div>
    <div
      class="full-width"
      *ngSwitchCase="request_steps_enums.LEASING_OPTIONS"
      id="div_full-width_bc9610ac"
    >
      <app-lease-options></app-lease-options>
    </div>
    <div class="full-width" *ngSwitchDefault id="div_full-width_5bf79b03">
      <app-review></app-review>
    </div>
  </div>
</div>

<p-confirmDialog
  header="Confirmation"
  position="top"
  width="450"
  id="p-confirmDialog_04123b8a"
>
</p-confirmDialog>
